import React from 'react';
import { LayoutOrientations } from '../../globals';
import MathUtils from '../../classes/utilities/MathUtils';

/**
 * renders a bar that fills as its progress prop is increased, from 0-100%
 *
 * use only for progress that has a known quantity. for unknown quantity, use a Spinner component instead
 * @export
 * @param {{
 * orientation: LayoutOrientations,
 * progress: Number,
 * className: String,
 * style: {},
 * showLabel: Boolean
 * }} props these special props may be used:
 * - orienatation: used to determine the direction of the bar; either Vertical or Horizontal *defaults to Horizontal*
 * - progress: a number between 0-1 that represents the fill rate of the bar in %
 * - className: an additional CSS class name to apply to the root div
 * - style: additional CSS properties to add or override the default styling
 * - showLabel: if true, a text label showing the completion rate in % will be displayed within the progress bar
 * @returns the stylized bar, with fill color according to the percentage of completion
 */
export default function ProgressBar(props)
{
	const orientation = props.orientation ? props.orientation : LayoutOrientations.Horizontal;

	return (
		<div
			className={[
				"progressBarRoot",
				(props.orientation ? props.orientation : LayoutOrientations.Vertical),
				(props.className ? props.className : ""),
			].join(' ')}
			style={props.style}
		>
			<div className={"progressBar "}
				style={
					orientation === LayoutOrientations.Horizontal ?
						{
							width: (MathUtils.clamp01(props.progress) * 100) + "%",
						}
						:
						{
							height: (MathUtils.clamp01(props.progress) * 100) + "%",
						}
				}
			/>
			{
				!props.showLabel ? null :
					<div className={"progressLabel"} style={props.labelStyle}>
						{Math.round(props.progress * 100) + "%"}
					</div>
			}
		</div>
	);
}